import ampLocale from '@amplify/amp-locale/dist/amp-locale';

import { DICTIONARY_KEYS, LANGUAGES } from './consts';

const dictionary = {
    [LANGUAGES.ENGLISH]: {
        [DICTIONARY_KEYS.VOCABULARY]: 'Vocabulary',
        [DICTIONARY_KEYS.START]: 'Start',
        [DICTIONARY_KEYS.RESUME]: 'Resume',
        [DICTIONARY_KEYS.DONE]: 'YOU ARE DONE',
        [DICTIONARY_KEYS.OK]: 'OK',
        [DICTIONARY_KEYS.YES]: 'Yes',
        [DICTIONARY_KEYS.NO]: 'No',
        [DICTIONARY_KEYS.ALL_FORMS_COMPLETED]: 'You have completed all available forms',
    },
    [LANGUAGES.SPANISH]: {
        [DICTIONARY_KEYS.VOCABULARY]: 'Vocabulario',
        [DICTIONARY_KEYS.START]: 'Comenzar',
        [DICTIONARY_KEYS.RESUME]: 'Reanudar',
        [DICTIONARY_KEYS.DONE]: 'TERMINASTE',
        [DICTIONARY_KEYS.OK]: 'OK',
        [DICTIONARY_KEYS.YES]: 'Sí',
        [DICTIONARY_KEYS.NO]: 'No',
        [DICTIONARY_KEYS.ALL_FORMS_COMPLETED]: 'Has completado todos los formularios disponibles',
    },
};

ampLocale.setDictionary(dictionary);

export const setLocalizationLanguage = appLanguage => ampLocale.setLanguage(appLanguage);

export default word => ampLocale.translate(word);
